import { Form, Skeleton } from "antd";
import ReferenceSelector from "./reference-selectors";
import { useMemo } from "react";

const ReferenceRenderer = ({ editing, editable, inputRef, dataIndex, save, toggleEdit, referenceList, referenceSingle, referenceLabel, referenceDisplayString, referenceDisplayStringNoSelect, referenceGetId, value, record, children }) => {
  const { data: reference } = referenceSingle(value, { skip: value === undefined });
  
  let childNode = children;

  const noSelect = useMemo(() => referenceDisplayStringNoSelect ? referenceDisplayStringNoSelect(record) : <em>Keine Auswahl</em>, [referenceDisplayStringNoSelect, record]);

  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{ margin: 0 }}
        name={dataIndex}
      >
        <ReferenceSelector
          referenceGetId={referenceGetId}
          referenceDisplayString={referenceDisplayString}
          referenceList={referenceList}
          showSearch
          defaultOpen
          ref={inputRef}
          style={{ width: 200 }}
          onBlur={save}
          onChange={save}
        />
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{ paddingInlineEnd: 24, cursor: "pointer" }}
        onClick={toggleEdit}
      >
        { reference ? (referenceLabel(reference) || referenceDisplayString(reference)) : (value === undefined ? noSelect : <Skeleton.Input active={true} size="small" />) }
      </div>
    );
  } else {
    childNode = reference ? (referenceLabel(reference) || referenceDisplayString(reference)) : (value === undefined ? noSelect : <Skeleton.Input active={true} size="small" />)
  }

  return <>{ childNode }</>
}

export default ReferenceRenderer;